module.exports = __webpack_public_path__ + "static/media/facebook.1e181067.png";